<template>
  <div>
    <v-card outlined>
      <v-data-table
        @dblclick:row="showUserRow"
        :loading-text="$t('appointment.table.loading')"
        :no-data-text="$t('appointment.table.noData')"
        :items-per-page="itemsPerPage"
        :headers="hausefulUsersList"
        :items="hausefulUsers"
        :loading="isLoading"
        mobile-breakpoint="20"
        class="clickable"
        hide-default-footer
        disable-sort
      >
        <template v-slot:[`item.name`]="{ item }">
          <span>
            {{ item.name }}
          </span>
          <span class="d-block caption grey--text">
            {{ formatDocument(item.cpf) }}
          </span>
        </template>
        <template v-slot:[`item.username`]="{ item }">
          <span>
            {{ item.username }}
          </span>
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <span>
            {{ $t(`roles.${item.type}`) }}
          </span>
        </template>
        <template v-slot:[`item.real_estate_name`]="{ item }">
          <span>
            {{ item.real_estate_name ? item.real_estate_name : '---' }}
          </span>
        </template>
        <template v-slot:[`item.id`]="{ item }">
          <div class="d-flex align-center justify-center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  :class="{ linked: item.checklist_id }"
                  :style="`background-image: url(${logoChecklist}`"
                  :alt="item.checklist_id ? $t('customer.label.checklistLinked') : $t('customer.label.checklistNotLinked')"
                  class="asaas"
                />
              </template>
              <span>
                {{ item.checklist_id ? $t('host.label.checklistLinked') : $t('host.label.checklistNotLinked')}}
              </span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <HausefulUsersListMenu
            @deleteUser="deleteUser"
            @updateUser="updateUser"
            @showUser="showUser"
            @impersonateUser="impersonateUser"
            @createUserOnChecklist="createUserOnChecklist"
            :user="item"
          />
        </template>
      </v-data-table>
    </v-card>

    <ModalImpersonate ref="impersonateModal" />

    <h-pagination :fetch="fetchHausefulUsers" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import { hausefulUsersList } from '../hausefulUsersTableHeaders'
import { catalogDateWithoutTime } from  '@/util/catalog'
import { formatDocument } from '@/util/document'

import HausefulUsersListMenu from './HausefulUsersListMenu'
import ModalImpersonate from "@/components/impersonate/ModalImpersonate.vue";
import logoChecklist from '@/assets/images/logo-hauseful-checklist.svg'

export default {
  name: 'HausefulUsersList',

  components: {
    ModalImpersonate,
    HausefulUsersListMenu,
  },

  computed: {
    ...mapGetters(['isLoading', 'itemsPerPage', 'hausefulUsers', 'filters'])
  },

  methods: {
    ...mapActions([
      'fetchHausefulUsers',
      'handleShowHausefulUsersDetails',
      'handleOpenDeleteHausefulUsersModal',
      'handleOpenCreateUpdateHausefulUsersModal',
      'handleOpenCreateUserOnChecklistModal',
    ]),

    showUserRow(_, { item }) {
      this.showUser(item.id)
    },

    showUser(id) {
      this.handleShowHausefulUsersDetails(id)
    },

    updateUser(id) {
      this.handleOpenCreateUpdateHausefulUsersModal(id)
    },

    impersonateUser(id) {
      this.$refs.impersonateModal.openModal(id, 'hausefulUser')
    },

    createUserOnChecklist(id) {
      this.handleOpenCreateUserOnChecklistModal(id)
    },

    deleteUser(id) {
      this.handleOpenDeleteHausefulUsersModal(id)
    },

    formatDate(date) {
      return date ? catalogDateWithoutTime(date) : '---'
    },
  },

  data() {
    return {
      formatDocument,
      hausefulUsersList,
      logoChecklist,
    }
  },

  mounted() {
    this.fetchHausefulUsers()
  }
}
</script>

<style>
.asaas {
  display: block;
  width: 22px;
  height: 22px;
  margin: 0 10px;
  border-radius: 50%;
  background-size: 20px;
  background-repeat: no-repeat;
  background-position: center 2px;
  background-color: #fff;
  box-shadow: 0 0 0 5px #fff;
}

.asaas.linked {
  background-position: center -32px;
}
</style>
